export default __webpack_public_path__ + "static/media/img-7.0c27f0b4.png";